import AppliedRoles from 'modules/Applied_Roles/reducers'
import Assessment from 'modules/Assessments/reducers'
import authReducer from 'modules/Auth/reducers'
import optoutStatus from 'modules/Dashboard/reducers'
import DriveDetails from 'modules/DriveDetails/reducers'
import Drive from 'modules/Drives/reducers'
import ManageProfile from 'modules/ManageProfile/reducers'
import OfferLetter from 'modules/OfferLetter/reducers'
import { onboarding } from 'modules/Onboarding/reducers'
import Resume from 'modules/Resume/reducers'
import Roles from 'modules/Roles/reducers'
import ViewRole from 'modules/ViewRole/reducers'
import { combineReducers } from 'redux'

export default combineReducers({
  auth: authReducer,
  studentData: onboarding,
  appliedRoleData: AppliedRoles,
  rolesListData: Roles,
  viewRoleDetails: ViewRole,
  userPreferenceData: ManageProfile,
  resumeData: Resume,
  driveData: Drive,
  driveDetails: DriveDetails,
  offerLetterData: OfferLetter,
  optoutStatus: optoutStatus,
  assessment: Assessment,
})
